/** 「246時間10分」のような値を、数字は大きく単位は小さく組む */
export function Figure({ value }: { value: string }) {
  return (
    <>
      {value.split(/(\d[\d,.]*)/).map((part, i) =>
        part === '' ? null : /^\d/.test(part) ? (
          // biome-ignore lint/suspicious/noArrayIndexKey: 分割結果の並びは固定
          <span key={i} className="figure__num">
            {part}
          </span>
        ) : (
          // biome-ignore lint/suspicious/noArrayIndexKey: 分割結果の並びは固定
          <span key={i} className="figure__unit">
            {part}
          </span>
        ),
      )}
    </>
  )
}
